import { useEffect } from 'react';

import { createHoverMedia } from './hoverMedia';

export const useHoverMediaEventListeners = (update: () => void) => {
  useEffect(() => {
    const hoverMedia = createHoverMedia();

    // Не поддерживаем старое API MediaQueryList.addListener потому что:
    // - MediaQueryList.addEventListener поддерживается в большинстве браузеров
    // - ситуация, что hoverMedia поменяется в рантайме, очень маловероятна
    hoverMedia?.addEventListener?.('change', update);

    return () => hoverMedia?.removeEventListener?.('change', update);
  }, [update]);
};
